import { Component, OnInit } from '@angular/core';
import { ParametrizacaoService } from '@modules/parametrizacao/services/parametrizacao.service';
import { IvasaoCompletaObject, ParametrizacaoObject } from '@modules/visitas/services/models';
import * as toastr from 'toastr'
@Component({
  selector: 'app-invasao-setor-completo',
  templateUrl: './invasao-setor-completo.component.html',
  styleUrls: ['./invasao-setor-completo.component.css']
})
export class InvasaoSetorCompletoComponent implements OnInit {
  
  fzsInvasor = "";
  fzsVago = "";
  qtdMeses = "";

  isLoading = false;

  isSAC = true;

  constructor(private parametrizacaoService: ParametrizacaoService) { }

  ngOnInit() {
  }

  saveInvasao(){
    console.log(this.fzsInvasor, "fzsInvasor");
    console.log(this.fzsVago, "fzsVago");
    console.log(this.qtdMeses, "qtdMeses");

    if(this.fzsInvasor == null){
      toastr.error('Campo "FZS Invasor" é obrigatório');
      return;
    }

    if(this.fzsVago == null){
      toastr.error('Campo "FZS Vago" é obrigatório');
      return;
    }

    if(this.qtdMeses == ""){
      toastr.error('A Combo "Período" é obrigatório');
      return;
    }

    let filtro = {
      invasor: this.fzsInvasor,
      vago: this.fzsVago,
      qtd: this.qtdMeses,
    }

    const params: IvasaoCompletaObject = {
      fzsInvasor: filtro.invasor,
      fzsVago: filtro.vago,
      qtdMeses: filtro.qtd
    }

    console.log(params)
    // typeof(params.yearMounthEnd);

    this.parametrizacaoService.saveInvasao(filtro).subscribe(
        resp=> {
                toastr.success("Invasão salva")
              },
        error => {
                toastr.error("Error ao salvar Invasão")
              }
    )

  }

  

  

}
